(function () {
  'use strict';

  function getRoot() {
    var root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function getCartUrl() {
    return getRoot() + 'cart';
  }

  function goToCart() {
    window.location.assign(getCartUrl());
  }

  function initLuxScreenProtection() {
    document
      .querySelectorAll('[data-lux-screen-protection]')
      .forEach(function (section) {
        if (section.dataset.initialized === 'true') return;
        section.dataset.initialized = 'true';

        var currentProductId = section.getAttribute(
          'data-current-product-id'
        );

        var protectionProductId = section.getAttribute(
          'data-protection-product-id'
        );

        var currentVariantId = section.getAttribute(
          'data-current-variant-id'
        );

        var mainProductPrice =
          parseInt(
            section.getAttribute('data-current-product-price'),
            10
          ) || 0;

        var mainProductCompareAtPrice =
          parseInt(
            section.getAttribute(
              'data-current-product-compare-at-price'
            ),
            10
          ) || 0;

        var protectionVariantId = section.getAttribute(
          'data-protection-variant-id'
        );

        var protectionPrice =
          parseInt(
            section.getAttribute('data-protection-price'),
            10
          ) || 0;

        var protectionCompareAtPrice =
          parseInt(
            section.getAttribute(
              'data-protection-compare-at-price'
            ),
            10
          ) || 0;

        var moneyFormat =
          section.getAttribute('data-money-format') || '{{amount}}€';

        var card = section.querySelector('[data-protection-card]');
        var action = section.querySelector('[data-protection-action]');
        var cardTotal = section.querySelector(
          '[data-protection-total]'
        );
        var cardSaving = section.querySelector(
          '[data-protection-saving]'
        );
        var summaryTitle = section.querySelector(
          '[data-summary-title]'
        );
        var summaryTotal = section.querySelector(
          '[data-summary-total]'
        );
        var summaryCopy = section.querySelector(
          '[data-summary-copy]'
        );
        var summarySaving = section.querySelector(
          '[data-summary-saving]'
        );
        var addButton = section.querySelector(
          '[data-protection-add]'
        );
        var message = section.querySelector(
          '[data-protection-message]'
        );
        var variantsData = section.querySelector(
          '[data-lux-product-variants]'
        );

        var popup = section.querySelector(
          '[data-lux-upsell-popup]'
        );
        var popupDialog = section.querySelector(
          '[data-upsell-dialog]'
        );
        var popupStatus = section.querySelector(
          '[data-upsell-status]'
        );
        var popupProducts = section.querySelector(
          '[data-upsell-products]'
        );
        var popupDismissButtons = section.querySelectorAll(
          '[data-upsell-dismiss], [data-upsell-skip]'
        );

        if (!card || !addButton || !popup || !popupProducts) return;

        /*
         * Movemos el drawer al body para evitar que el tema limite
         * el position: fixed dentro de la ficha de producto.
         */
        if (popup.parentNode !== document.body) {
          document.body.appendChild(popup);
        }

        var productVariants = [];
        var isProtectionSelected = true;
        var currentVariantAvailable = true;
        var isSubmitting = false;

        try {
          productVariants = variantsData
            ? JSON.parse(variantsData.textContent)
            : [];
        } catch (error) {
          productVariants = [];
        }

        function formatMoney(cents) {
          if (
            window.Shopify &&
            typeof window.Shopify.formatMoney === 'function'
          ) {
            return window.Shopify.formatMoney(
              cents,
              moneyFormat
            );
          }

          return (cents / 100).toLocaleString('es-ES', {
            style: 'currency',
            currency: 'EUR'
          });
        }

        function comparablePrice(compareAt, price) {
          compareAt = parseInt(compareAt, 10) || 0;
          price = parseInt(price, 10) || 0;

          return compareAt > price ? compareAt : price;
        }

        function getProductFormVariantId() {
          var forms = Array.prototype.slice.call(
            document.querySelectorAll(
              'form[action*="/cart/add"]'
            )
          );

          var form = forms.find(function (item) {
            return !item.closest(
              '[data-lux-screen-protection]'
            );
          });

          var input = form
            ? form.querySelector('[name="id"]')
            : null;

          return input && input.value
            ? input.value
            : currentVariantId;
        }

        function getCurrentVariantData() {
          var variantId = String(getProductFormVariantId());

          var variant = productVariants.find(function (item) {
            return String(item.id) === variantId;
          });

          return (
            variant || {
              id: variantId,
              price: mainProductPrice,
              compare_at_price: mainProductCompareAtPrice,
              available: true
            }
          );
        }

        function calculateSaving() {
          var mainComparable = comparablePrice(
            mainProductCompareAtPrice,
            mainProductPrice
          );

          var protectionComparable = comparablePrice(
            protectionCompareAtPrice,
            protectionPrice
          );

          return Math.max(
            mainComparable +
              protectionComparable -
              mainProductPrice -
              protectionPrice,
            0
          );
        }

        function clearMessage() {
          message.textContent = '';
          message.classList.remove(
            'is-error',
            'is-success'
          );
        }

        function setMessage(text, type) {
          message.textContent = text;
          message.classList.remove(
            'is-error',
            'is-success'
          );

          if (type) {
            message.classList.add('is-' + type);
          }
        }

        function updateInterface() {
          var total = isProtectionSelected
            ? mainProductPrice + protectionPrice
            : mainProductPrice;

          var saving = isProtectionSelected
            ? calculateSaving()
            : 0;

          card.classList.toggle(
            'is-selected',
            isProtectionSelected
          );

          card.setAttribute(
            'aria-pressed',
            isProtectionSelected ? 'true' : 'false'
          );

          action.textContent = isProtectionSelected
            ? 'Continuar sin protección'
            : 'Añadir protección';

          cardTotal.textContent = formatMoney(
            mainProductPrice + protectionPrice
          );

          cardSaving.textContent =
            calculateSaving() > 0
              ? 'Ahorras ' +
                formatMoney(calculateSaving())
              : 'Protección opcional';

          summaryTotal.textContent = formatMoney(total);

          if (isProtectionSelected) {
            summaryTitle.textContent =
              'Protección de pantalla añadida';

            summaryCopy.textContent =
              'Incluye este producto + 2 protectores de pantalla.';

            summarySaving.textContent =
              saving > 0
                ? 'Ahorras ' +
                  formatMoney(saving) +
                  ' comprándolo junto.'
                : '';

            addButton.textContent =
              'Añadir con protección';
          } else {
            summaryTitle.textContent =
              'Continuar sin protección';

            summaryCopy.textContent =
              'Se añadirá únicamente el producto seleccionado.';

            summarySaving.textContent = '';

            addButton.textContent =
              'Añadir sin protección';
          }

          addButton.disabled =
            !currentVariantAvailable || isSubmitting;
        }

        function updateMainProduct() {
          var variant = getCurrentVariantData();

          currentVariantId = variant.id;
          mainProductPrice =
            parseInt(variant.price, 10) || 0;

          mainProductCompareAtPrice =
            parseInt(
              variant.compare_at_price,
              10
            ) || 0;

          currentVariantAvailable =
            variant.available !== false;

          updateInterface();
        }

        function toggleProtection() {
          if (isSubmitting) return;

          clearMessage();
          isProtectionSelected =
            !isProtectionSelected;

          updateInterface();
        }

        function restoreButton() {
          isSubmitting = false;

          addButton.disabled =
            !currentVariantAvailable;

          addButton.textContent =
            isProtectionSelected
              ? 'Añadir con protección'
              : 'Añadir sin protección';
        }

        function dispatchCartEvents() {
          document.dispatchEvent(
            new CustomEvent('cart:refresh')
          );

          document.dispatchEvent(
            new CustomEvent('cart:updated')
          );
        }

        function optimizeImageUrl(src, width) {
          if (!src) return '';

          try {
            var url = new URL(
              src,
              window.location.origin
            );

            url.searchParams.set(
              'width',
              String(width || 420)
            );

            return url.toString();
          } catch (error) {
            return src;
          }
        }

        function getAvailableVariants(product) {
          return (product.variants || []).filter(
            function (variant) {
              return variant.available;
            }
          );
        }

        function setPrice(priceBox, variant) {
          priceBox.textContent = '';

          var strong =
            document.createElement('strong');

          strong.textContent = formatMoney(
            variant.price || 0
          );

          priceBox.appendChild(strong);

          if (
            variant.compare_at_price &&
            variant.compare_at_price >
              variant.price
          ) {
            var del =
              document.createElement('del');

            del.textContent = formatMoney(
              variant.compare_at_price
            );

            priceBox.insertBefore(
              del,
              strong
            );
          }
        }

        function addUpsellVariant(
          button,
          variantId,
          cardMessage
        ) {
          if (!variantId || button.disabled) return;

          button.disabled = true;
          button.textContent = 'Añadiendo...';
          cardMessage.textContent = '';

          fetch(getRoot() + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: Number(variantId),
                  quantity: 1
                }
              ]
            })
          })
            .then(function (response) {
              if (!response.ok) {
                return response
                  .json()
                  .then(function (error) {
                    throw error;
                  });
              }

              return response.json();
            })
            .then(function () {
              dispatchCartEvents();
              goToCart();
            })
            .catch(function (error) {
              cardMessage.textContent =
                error && error.description
                  ? error.description
                  : 'No se ha podido añadir este producto.';

              button.disabled = false;
              button.textContent = 'Añadir';
            });
        }

        function createProductCard(product) {
          var variants =
            getAvailableVariants(product);

          if (!variants.length) return null;

          var selectedVariant = variants[0];

          var article =
            document.createElement('article');

          article.className =
            'lux-upsell-product';

          var imageWrap =
            document.createElement('div');

          imageWrap.className =
            'lux-upsell-product__image';

          if (product.featured_image) {
            var image =
              document.createElement('img');

            image.src = optimizeImageUrl(
              product.featured_image,
              420
            );

            image.alt = product.title || '';
            image.width = 420;
            image.height = 420;
            image.loading = 'lazy';
            image.decoding = 'async';

            imageWrap.appendChild(image);
          }

          var body =
            document.createElement('div');

          body.className =
            'lux-upsell-product__body';

          var title =
            document.createElement('h4');

          title.className =
            'lux-upsell-product__title';

          title.textContent =
            product.title ||
            'Producto recomendado';

          body.appendChild(title);

          var price =
            document.createElement('div');

          price.className =
            'lux-upsell-product__price';

          var select = null;

          if (variants.length > 1) {
            select =
              document.createElement('select');

            select.className =
              'lux-upsell-product__variant';

            select.setAttribute(
              'aria-label',
              'Elige una opción'
            );

            variants.forEach(
              function (variant) {
                var option =
                  document.createElement(
                    'option'
                  );

                option.value = variant.id;

                option.textContent =
                  (
                    variant.public_title ||
                    variant.title ||
                    'Opción'
                  ) +
                  ' · ' +
                  formatMoney(
                    variant.price || 0
                  );

                select.appendChild(option);
              }
            );

            select.addEventListener(
              'change',
              function () {
                selectedVariant =
                  variants.find(
                    function (variant) {
                      return (
                        String(variant.id) ===
                        String(select.value)
                      );
                    }
                  ) || variants[0];

                setPrice(
                  price,
                  selectedVariant
                );
              }
            );

            body.appendChild(select);
          }

          setPrice(price, selectedVariant);
          body.appendChild(price);

          var cardMessage =
            document.createElement('p');

          cardMessage.className =
            'lux-upsell-product__message';

          cardMessage.setAttribute(
            'aria-live',
            'polite'
          );

          var add =
            document.createElement('button');

          add.type = 'button';
          add.className =
            'lux-upsell-product__add';

          add.textContent = 'Añadir';

          add.addEventListener(
            'click',
            function () {
              addUpsellVariant(
                add,
                selectedVariant.id,
                cardMessage
              );
            }
          );

          body.appendChild(cardMessage);
          body.appendChild(add);

          article.appendChild(imageWrap);
          article.appendChild(body);

          return article;
        }

        function renderRecommendations(products) {
          popupProducts.textContent = '';

          products.forEach(function (product) {
            var cardElement =
              createProductCard(product);

            if (cardElement) {
              popupProducts.appendChild(
                cardElement
              );
            }
          });

          return popupProducts.children.length;
        }

        function showPopup() {
          popup.hidden = false;
          popup.setAttribute(
            'aria-hidden',
            'false'
          );

          document.body.classList.add(
            'lux-upsell-open'
          );

          window.requestAnimationFrame(
            function () {
              popup.classList.add('is-open');

              if (popupDialog) {
                popupDialog.focus();
              }
            }
          );
        }

        function loadRecommendations() {
          if (!currentProductId) {
            goToCart();
            return;
          }

          /*
           * La popup permanece oculta mientras se consulta
           * Search & Discovery.
           */
          popup.classList.remove('is-open');
          popup.hidden = true;

          popup.setAttribute(
            'aria-hidden',
            'true'
          );

          if (popupStatus) {
            popupStatus.textContent = '';
          }

          popupProducts.textContent = '';

          var endpoint =
            getRoot() +
            'recommendations/products.json' +
            '?product_id=' +
            encodeURIComponent(
              currentProductId
            ) +
            '&limit=3' +
            '&intent=complementary';

          fetch(endpoint, {
            headers: {
              Accept: 'application/json'
            }
          })
            .then(function (response) {
              if (!response.ok) {
                throw new Error(
                  'Recommendations error'
                );
              }

              return response.json();
            })
            .then(function (data) {
              var products =
                (data.products || []).filter(
                  function (product) {
                    return (
                      product.available &&
                      String(product.id) !==
                        String(
                          currentProductId
                        ) &&
                      String(product.id) !==
                        String(
                          protectionProductId
                        ) &&
                      getAvailableVariants(
                        product
                      ).length > 0
                    );
                  }
                );

              var count =
                renderRecommendations(
                  products.slice(0, 3)
                );

              /*
               * Si no hay complementarios, no se muestra
               * absolutamente nada y se va al carrito.
               */
              if (!count) {
                goToCart();
                return;
              }

              if (popupStatus) {
                popupStatus.textContent = '';
              }

              showPopup();
            })
            .catch(function () {
              /*
               * Si falla Search & Discovery, tampoco se
               * abre el drawer.
               */
              goToCart();
            });
        }

        function addSelectionToCart() {
          if (isSubmitting) return;

          clearMessage();
          updateMainProduct();

          if (!currentVariantAvailable) {
            setMessage(
              'La variante seleccionada no está disponible ahora mismo.',
              'error'
            );

            return;
          }

          var items = [
            {
              id: Number(currentVariantId),
              quantity: 1
            }
          ];

          if (isProtectionSelected) {
            items.push({
              id: Number(
                protectionVariantId
              ),
              quantity: 1
            });
          }

          if (!items[0].id) {
            setMessage(
              'No se ha podido detectar la variante seleccionada.',
              'error'
            );

            return;
          }

          isSubmitting = true;
          addButton.disabled = true;
          addButton.textContent =
            'Añadiendo...';

          fetch(getRoot() + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type':
                'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: items
            })
          })
            .then(function (response) {
              if (!response.ok) {
                return response
                  .json()
                  .then(function (error) {
                    throw error;
                  });
              }

              return response.json();
            })
            .then(function () {
              setMessage(
                isProtectionSelected
                  ? 'Producto y protección añadidos al carrito.'
                  : 'Producto añadido sin protección.',
                'success'
              );

              dispatchCartEvents();
              loadRecommendations();
            })
            .catch(function (error) {
              setMessage(
                error && error.description
                  ? error.description
                  : 'No se ha podido añadir la selección al carrito.',
                'error'
              );

              restoreButton();
            });
        }

        card.addEventListener(
          'click',
          toggleProtection
        );

        card.addEventListener(
          'keydown',
          function (event) {
            if (
              event.key === 'Enter' ||
              event.key === ' '
            ) {
              event.preventDefault();
              toggleProtection();
            }
          }
        );

        addButton.addEventListener(
          'click',
          addSelectionToCart
        );

        popupDismissButtons.forEach(
          function (button) {
            button.addEventListener(
              'click',
              goToCart
            );
          }
        );

        popup.addEventListener(
          'keydown',
          function (event) {
            if (event.key === 'Escape') {
              event.preventDefault();
              goToCart();
            }
          }
        );

        document.addEventListener(
          'change',
          function (event) {
            if (
              event.target &&
              event.target.matches(
                'form[action*="/cart/add"] [name="id"]'
              )
            ) {
              window.setTimeout(
                updateMainProduct,
                50
              );
            }
          }
        );

        document.addEventListener(
          'variant:change',
          function () {
            window.setTimeout(
              updateMainProduct,
              50
            );
          }
        );

        var lastVariantId = String(
          getProductFormVariantId()
        );

        window.setInterval(
          function () {
            var nextVariantId = String(
              getProductFormVariantId()
            );

            if (
              nextVariantId !==
              lastVariantId
            ) {
              lastVariantId =
                nextVariantId;

              updateMainProduct();
            }
          },
          600
        );

        updateMainProduct();
      });
  }

  if (window.LuxProtectionBundle) {
    window.LuxProtectionBundle.init();
    return;
  }

  window.LuxProtectionBundle = {
    init: initLuxScreenProtection
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initLuxScreenProtection
    );
  } else {
    initLuxScreenProtection();
  }

  document.addEventListener(
    'shopify:section:load',
    initLuxScreenProtection
  );
})();